import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = { baseURL: siteConfig.siteUrl.API_URL };

const headers = () => ({
    Authorization: localStorage.getItem('access_token'),
    AuthId:        localStorage.getItem('id_token'),
    token:         localStorage.getItem('id_token'),
});

function* getVales(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({ url: `api/vales-consumo${query}`, headers: headers() });
    if (res.data.success) {
        yield put({ type: actions.GET_VALES_SUCCESS, payload: res.data.vales });
    } else {
        notification('error', 'Error al cargar vales de consumo');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* getVale(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: `api/vales-consumo/${action.id}`, headers: headers() });
    if (res.data.success) {
        yield put({ type: actions.GET_VALE_SUCCESS, payload: res.data.vale });
    } else {
        notification('error', 'Error al cargar vale de consumo');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* updateEstado(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({
        url: `api/vales-consumo/${action.id}/estado`,
        method: 'PUT',
        data: action.payload,
        headers: headers(),
    });
    if (res.data.success) {
        notification('success', res.data.msg);
        yield put({ type: actions.UPDATE_ESTADO_VALE_SUCCESS, id: action.id, estado: action.payload.estado });
    } else {
        notification('error', res.data.msg || 'Error al actualizar estado');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

export default function* valesConsumoSagas() {
    yield all([
        takeEvery(actions.GET_VALES_REQUEST,          getVales),
        takeEvery(actions.GET_VALE_REQUEST,            getVale),
        takeEvery(actions.UPDATE_ESTADO_VALE_REQUEST,  updateEstado),
    ]);
}
